import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, Input, Label } from 'reactstrap';
import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';
export default function SecuritySettings({
  securitySettings,
  saveIntegration,
  isSuperAdmin,
}) {
  const [dailyCallLimit, setDailyCallLimit] = useState(
    securitySettings?.dailyCallLimit !== undefined
      ? securitySettings?.dailyCallLimit
      : 100
  );
  const [previewCallLimit, setPreviewCallLimit] = useState(
    securitySettings?.previewCallLimit !== undefined
      ? securitySettings?.previewCallLimit
      : -1
  );

    const [availablePreviewCallMins, setAvailablePreviewCallMins] = useState(
    securitySettings?.availablePreviewCallMins !== undefined
      ? securitySettings?.availablePreviewCallMins
      : -1
  );
  const [concurrentCallLimit, setConcurrentCallLimit] = useState(
    securitySettings?.concurrentCallLimit !== undefined
      ? securitySettings?.concurrentCallLimit
      : -1
  );

  useEffect(() => {
    setDailyCallLimit(
      securitySettings?.dailyCallLimit !== undefined
        ? securitySettings?.dailyCallLimit
        : 100
    );
    setConcurrentCallLimit(
      securitySettings?.concurrentCallLimit !== undefined
        ? securitySettings?.concurrentCallLimit
        : -1
    );

    setPreviewCallLimit(securitySettings?.previewCallLimit??0);
    setAvailablePreviewCallMins(securitySettings?.availablePreviewCallMins??0);
  }, [securitySettings]);


  const handleDailyCallLimitChange = (e) => {
    const value = e.target.value;
    setDailyCallLimit(value);
  };

  const handleConcurrentCallLimitChange = (e) => {
    const value = e.target.value;
    setConcurrentCallLimit(value);
  };

  const handlePreviewCallLimitChange = (e) => {
    const value = e.target.value;

    if(value < 0 || value > 200){
      return;
    }
    setPreviewCallLimit(value);
  };

  const handleSave = () => {
    let security = {
      dailyCallLimit: dailyCallLimit,
      concurrentCallLimit: concurrentCallLimit,
    };

    if (isSuperAdmin) {
      security.previewCallLimit = previewCallLimit;
    }
    saveIntegration({ security: security });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Keep your Voice AI Secure</h6>
        </div>
        <Separator className="mb-3" />
        <Card className="m-4">
          <Colxx xxs="12" className="pl-4 py-3">
            <div className="mb-2">
              <div className="mt-2">
                <h6>Daily call limit</h6>
                <p className="mb-1">The maximum number of calls allowed per day. (-1 for no limit)</p>
                <div className="d-flex">
                  <Input
                    type="number"
                    name="dailyCallLimit"
                    className="form-control"
                    value={dailyCallLimit}
                    style={{ width: '70%' }}
                    onChange={handleDailyCallLimitChange}
                    min={-1}
                  />
                </div>
              </div>
              <div className="mt-3">
                <h6>Concurrent call limit</h6>
                <p className="mb-1">
                  The maximum number of concurrent calls allowed. (-1 for no limit)
                </p>
                <div className="d-flex">
                  <Input
                    type="number"
                    name="concurrentCallLimit"
                    className="form-control"
                    style={{ width: '70%' }}
                    value={concurrentCallLimit}
                    onChange={handleConcurrentCallLimitChange}
                    min={-1}
                  />
                </div>
              </div>

              {
                isSuperAdmin && <div className="mt-3">
                <h6>Preview call limit {`(For Testing)`}</h6>
                <p className="mb-1">
                  Number of minutes intended for testing and validation purposes.
                </p>
                <div className="d-flex">
                  <Input
                    type="number"
                    name="previewCallLimit"
                    className="form-control"
                    style={{ width: '70%' }}
                    value={previewCallLimit}
                    onChange={handlePreviewCallLimitChange}
                    min={-1}
                    max={200}
                  />
                </div>
                <p className="text-muted mt-1">
                  {availablePreviewCallMins} of {previewCallLimit} left
                </p>
              </div>
              }
            </div>
          </Colxx>
        </Card>
        <Separator className="my-3" />
        <div className="text-center mt-4 mb-2">
          <Button color="primary" size="xs" onClick={handleSave}>
            Save
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
